import * as React from "react";
import { Context } from "./_context";
export const PrinterIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.897 4.505A1 1 0 0 0 2 5.5V17a1 1 0 0 0 1 1h2.5v3a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-3H21a1 1 0 0 0 1-1V5.5l-.005-.103A1 1 0 0 0 21 4.5H3l-.103.005ZM16.5 14.5V20h-9v-5.5h9ZM20 16h-1.5v-2.5a1 1 0 0 0-.898-.995L17.5 12.5h-11a1 1 0 0 0-.995.898L5.5 13.5V16H4V6.5h16V16Zm-6-5.5h4v-2h-4v2Z", fill: "currentColor" }));
  return iconset[size];
};
PrinterIcon.iconId = "CwSa11";
